<template lang="pug">
   v-card
      v-toolbar(dark dense color="red" class="navFixed")
        v-toolbar-title IM Preview 
        v-spacer
        v-toolbar-items
          v-btn(v-if="activeStatus == 9 && !tembusan.includes(viewer._id)" flat @click="forwardDialog = true")
            v-icon forward
            | &nbsp; Forward
          v-dialog(v-model="forwardDialog" persistent max-width="500px")
            v-card()
              v-card-title(class="headline grey lighten-2") IM Forward
              v-card-text
                v-layout(wrap)
                  v-flex(xs12 v-if="approval == 3" style="color:#ff2c03;") User tujuan forward
                  v-flex( xs12)
                    v-autocomplete(
                      v-model="userForward"
                      label="Select User"
                      :items="users"
                      color="blue-grey lighten-2"
                      item-text="name"
                      item-value="data"
                      return-object
                      chips
                      clearable
                      solo
                    )
                      template(v-slot:selection="data")
                        v-chip(:input-value="data.selected" color="blue-grey" class="white--text" v-on="on") {{data.item.name ? data.item.name : data.item.fullname}}
                      template(v-slot:item="data")
                        template
                          v-list-tile-content
                            v-list-tile-title(v-html="data.item.name ? data.item.name : data.item.fullname")
                            v-list-tile-sub-title(v-html="data.item.title ? data.item.title : data.item.title")
                  v-flex(xs12)
                    v-textarea(
                      v-model="forwardNote"
                      box
                      label="Comment (Optional)"
                      auto-grow
                      value=""
                    )
              v-card-actions
                v-spacer
                v-btn(color="blue darken-1" flat @click.native="forwardDialog = false") Close
                div(class="text-xs-center")
                  v-btn(:disabled="forwardDialog2" :loading="forwardDialog2" color="blue darken-1" flat @click="forwardDialog2 = true") Submit
                  v-dialog(
                    v-model="forwardDialog2"
                    hide-overlay
                    persistent
                    width="300")
                    v-card(color="primary" dark)
                      v-card-text Processing. Please wait!
                        v-progress-linear(indeterminate color="white" class="mb-0")

          v-btn(v-if="viewer.forward == 1" flat @click="replyDialog = true")
            v-icon reply
            | &nbsp; Reply
          v-dialog(v-model="replyDialog" persistent max-width="500px")
            v-card()
              v-card-title(class="headline grey lighten-2") IM Reply
              v-card-text
                v-layout(wrap)
                  v-flex(xs12)
                    v-textarea(
                      v-model="replyNote"
                      box
                      label="Comment (Optional)"
                      auto-grow
                      value=""
                    )

              v-card-actions
                v-spacer
                v-btn(color="blue darken-1" flat @click.native="replyDialog = false") Close
                div(class="text-xs-center")
                  v-btn(:disabled="replyDialog2" :loading="replyDialog2" color="blue darken-1" flat @click="replyDialog2 = true") Submit
                  v-dialog(
                    v-model="replyDialog2"
                    hide-overlay
                    persistent
                    width="300")
                    v-card(color="primary" dark)
                      v-card-text Processing. Please wait!
                        v-progress-linear(indeterminate color="white" class="mb-0")

          v-btn(v-if="(activeStatus == 9 || activeStatus == 3) && !tembusan.includes(viewer._id)" flat :to="{ path: '/login', query: {r: getEditUrl(imItems.imType, imItems._id), workflow: imItems.imWorkflow}}" replace)
            v-icon edit
            | &nbsp; Edit
          v-btn(v-if="imItems.imFileLampiran" flat @click="download(imItems.imFileLampiran)" title="Download Lampiran")
            v-icon cloud_download
            | &nbsp; Lampiran
          v-btn(v-if="(activeStatus == 9 || activeStatus == 3) && !tembusan.includes(viewer._id)" flat title='Approval' @click="approvalDialog = true" color="black" class="blink") 
            v-icon(title="Approval") assignment_turned_in
            | &nbsp;Approval
          v-dialog(v-model="approvalDialog" persistent max-width="500px")
            v-card()
              v-card-title(class="headline grey lighten-2") Approval Form
              v-card-text
                v-layout(wrap)
                  v-flex(xs12)
                    v-radio-group(v-model="approval" row)
                      v-radio(v-if="imItems.imStatus != 3" label="Approve" color="success" value="7")
                      v-radio(v-if="imItems.imStatus != 3" label="Reject" color="red" value="8")
                      v-radio(label="Need Review" color="yellow darken-4" value="3")
                    span(v-if="approval == 3" style="color:#ff2c03;") Approval akan dimulai lagi dari approver yang dipilih!
                  v-flex(v-if="approval == 3" xs12)
                    v-select(
                      v-model="select"
                      :hint="jabatan"
                      :items="reviewer"
                      item-text="fullname"
                      item-value="data"
                      label="Select"
                      persistent-hint
                      return-object
                      single-line
                      dense)
                  v-flex(xs12)
                    v-textarea(
                      v-model="comment"
                      box
                      label="Comment (Optional)"
                      auto-grow
                      value=""
                    )
              v-card-actions
                v-spacer
                v-btn(color="blue darken-1" flat @click.native="approvalDialog = false") Close
                div(class="text-xs-center")
                  v-btn(:disabled="!select.hasOwnProperty('id') && approval == 3" :loading="approvalDialog2" color="blue darken-1" flat @click="approvalDialog2 = true") Submit
                  v-dialog(
                    v-model="approvalDialog2"
                    hide-overlay
                    persistent
                    width="300")
                    v-card(color="primary" dark)
                      v-card-text Processing. Please wait!
                        v-progress-linear(indeterminate color="white" class="mb-0")
          v-btn(flat @click='printIM(imItems._id)')
            v-icon print
            | &nbsp; Print 
          v-btn(dark flat onclick="javascript:window.close();") 
            v-icon(title="Close") cancel
            | &nbsp;Close
      v-list(three-line subheader class="print-bg padTop60")
        div(:id="imItems._id")
          .page(size="Auto")
            div(class="view-width" style="font-size:12px;")
              p(class="ma-0 display-1") {{ imItems.imGroup == 'bcg' ? 'PT. Berau Coal' : 'PT. GEMS' }}
              v-flex(ma-0 pa-0 xs12 d-flex)
                span(class="headline") CAPEX Approval
                span(class="headline print-header" v-if="imItems.imBudgeted") Budgeted ( {{imItems.imBudgeted}} )
                span(class="headline print-header" v-else="imItems.imBudgeted") Non-Budgeted
              hr(style="border-style: inset; border-width: 2px; margin-bottom: 1vh;")
              v-flex(mb-1)
                p(class="ma-0 subtitle-1") Project Title:
                p(class="font-weight-bold title") {{imItems.imPerihal}}
              v-layout(row wrap)
                v-flex(xs6) 
                  div(class="ma-0 subtitle-1") Creator:
                  div(class="font-weight-bold title") {{ imItems.imUser.fullname }}
                v-flex(xs6 sm6 pl-3 v-if="imItems.imValue.value >= 100000")                        
                  p(v-show="projectOwner" class="ma-0 subtitle-1") Project Owner:
                  p(class="font-weight-bold title ma-0 pb-1") {{ projectOwner }}        
            div(class="view-width detail-wrap" style="position:relative;font-size:14px;height:25cm;")
              div(id="background")
                img(v-if="imItems.imStatus == 1" src="img/draft.png" class="imgWaterMark")
                img(v-if="imItems.imStatus == 2" src="img/on-approval.png" class="imgWaterMark")
                img(v-if="imItems.imStatus == 4" src="img/fully-approved.png" class="imgWaterMark")
                img(v-if="imItems.imStatus == 5" src="img/withdraw.png" class="imgWaterMark")
                img(v-if="imItems.imStatus == 8" src="img/rejected.png" class="imgWaterMark")
              table(class="view-width" border="1" style="border:1px solid black;border-collapse: collapse;text-align:center;z-index:100;")
                tbody
                  tr
                    td(colspan="3" style="") 
                      b Approved by,
                  tr
                    td(width="36%") 
                      b Name/Position
                    td(width="32%") 
                      b Comment
                    td(width="32%")
                      b Digital Signature
                  tr(v-for="(item, index) in imItems.imWorkflow" v-if="item.postAs == 'requestor' || item.postAs == 'budgetor' || item.postAs == 'approver' || item.postAs == 'bod'" height="80px")
                    td(width="40%" class="px-3")
                      b(v-if="item.fullname") {{ item.fullname }} / {{ item.title }}
                      b(v-else) {{ item.name }} / {{ item.title }}
                    td {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                    td
                      div(v-if="item.status == 7" class="approved") 
                        img(src="../assets/check-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                      div(v-else-if="item.status == 8" class="approved") 
                        img(src="../assets/close-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                      div(v-else class="approved ff0000") &nbsp; <br />&nbsp; <br />&nbsp; <br />
              //- br
              //- span(style="font-size:14px;font-weight:bold;color:red;") Scan QR code to validate the correctness of information regarding the digital signatures on this document.
              //- p
              //-   img(:src="`${API_URL}/qr/generate/${imItems.imNo}/${imItems.imType}`" style="vertical-align:middle;width:150px;")
            div(class="view-width" style="text-align:justify;margin-top:15px;")
              h4(style="font-size:15px;") 1. Executive Summary
              div(v-html="imItems.imExecutiveSummary" class="ck-content ml-3")
            div(class="view-width" style="text-align:justify;margin-top:15px;")
              h4(style="font-size:15px;") 2. Background
              div(v-html="imItems.imLatarBelakang" class="ck-content  ml-3")
            div(class="view-width" style="text-align:justify;margin-top:15px;")
              h4(style="font-size:15px;") 3. Project goals, objectives and expected benefits
              div(v-html="imItems.imTujuan" class="ck-content ml-3")
            div(class="view-width" style="text-align:justify;margin-top:15px;")
              h4(style="font-size:15px;") 4. Scope
              div(v-html="imItems.imScope" class="ck-content ml-3")
            div(class="view-width" style="text-align:justify;margin-top:15px;margin-bottom:26px;")
              h4(style="font-size:15px;") 5. Overview and rational of investment
              table(class="view-width ml-3" border="1" style="border:1px solid black;border-collapse: collapse;text-align: left;z-index:100;")
                tbody
                  tr
                    td(width="30%" class="pa-2") 
                      b Project Description
                    td(width="60%" class="pa-2") 
                      p {{ imItems.imOverview.projectDesc }}
                  tr
                    td(class="pa-2")
                      b Reason investment needed including the benefits (incl. non financial benefit)
                    td(class="pa-2")
                      p {{ imItems.imOverview.reasonInvestment }}
                  tr
                    td(class="pa-2")
                      b Key permits / approvals needed
                    td(class="pa-2")
                      p {{ imItems.imOverview.keyPermit }}
                  tr
                    td(class="pa-2")
                      b Partners / suppliers
                    td(class="pa-2")
                      p {{ imItems.imOverview.partners }}
                  tr
                    td(class="pa-2")
                      b Timescale
                    td(class="pa-2")
                      p {{ imItems.imOverview.timescale }}
                  tr
                    td(class="pa-2")
                      b Location / site
                    td(class="pa-2")
                      p {{ imItems.imOverview.location }}
                  tr
                    td(class="pa-2")
                      b Fit with Company Strategy
                    td(class="pa-2")
                      p {{ imItems.imOverview.isFit }}
                  tr
                    td(class="pa-2")
                      b Expansionary or Sustaining capex? Please state how much additional tonnage if expansionary
                    td(class="pa-2")
                      p {{ imItems.imOverview.isExpansionary }}
                  tr
                    td(class="pa-2")
                      b Impact on cost per ton
                    td(class="pa-2")
                      p {{ imItems.imOverview.impactCost }}
                  tr
                    td(class="pa-2")
                      b Describe how the project fits into the current approved mine plan
                    td(class="pa-2")
                      p {{ imItems.imOverview.isFitMinePlan }}
            div(class="view-width" style="text-align:justify;")
              h4(style="font-size:15px;") 6. Project Cost
              table(class="view-width ml-3" border="1" style="border:1px solid black;border-collapse: collapse;text-align: left;z-index:100;")
                tbody
                  tr
                    td(width="30%" class="pa-2") 
                      b Project Cost ($)
                    td(width="60%" class="pa-2") 
                      p {{ imItems.imValue.currency }} {{ getFormatCurrency(imItems.imValue.value) }}
                  tr
                    td(class="pa-2")
                      b NPV @ 12%
                    td(class="pa-2")
                      p {{ imItems.imValue.npv }}
                  tr
                    td(class="pa-2")
                      b IRR
                    td(class="pa-2")
                      p {{ imItems.imValue.irr }}
                  //- tr
                  //-   td(class="pa-2")
                  //-     b Return on investment
                  //-   td(class="pa-2")
                  //-     p {{ imItems.imValue.roi }}
                  tr
                    td(class="pa-2")
                      b Cash Payback Period (Years)
                    td(class="pa-2")
                      p {{ imItems.imValue.cashbackPeriod }}
                  tr
                    td(class="pa-2")
                      b Describe how the project will be financed
                    td(class="pa-2")
                      p {{ imItems.imValue.howFinanced }}
            div(class="view-width" style="text-align:justify;margin-top:15px;")
              h4(style="font-size:15px;") 7. Opportunities and risks
              table(class="view-width ml-3" border="1" style="border:1px solid black;border-collapse: collapse;text-align: left;z-index:100;")
                tbody
                  tr
                    td(width="30%" class="pa-2") 
                      b Opportunity
                    td(width="60%" class="pa-2") 
                      div(v-html="imItems.imOpportunity")
                  tr
                    td(class="pa-2")
                      b Risk
                    td(class="pa-2")
                      div(v-html="imItems.imRisk")
            div(class="view-width" style="text-align:justify;margin-top:15px;")
              h4(style="font-size:15px;") 8. Alternative options
              div(class="view-width ml-3") Please describe whether any alternative options were considered and why you are proposing this particular solution. Also, please state the impact of not progressing with any option.
              table(class="view-width ml-3" border="1" style="border:1px solid black;border-collapse: collapse;text-align: left;z-index:100;")
                tbody
                  tr
                    td(width="30%" class="pa-2") 
                      b Do nothing
                    td(width="60%" class="pa-2") 
                      div(v-html="imItems.imDoNothing")
                  tr
                    td(class="pa-2")
                      b Alternative Option
                    td(class="pa-2")
                      div(v-html="imItems.imAltOption")
            div(class="view-width" v-if="imItems.imValue.value >= 100000" style="text-align:justify;margin-top:15px;")
              h4(style="font-size:15px;") 9. Project Team
              div(class="view-width detail-wrap" style="position:relative;font-size:14px;")
                div(id="background")
                  img(v-if="imItems.imStatus == 1" src="img/draft.png" class="imgWaterMark")
                  img(v-if="imItems.imStatus == 2" src="img/on-approval.png" class="imgWaterMark")
                  img(v-if="imItems.imStatus == 4" src="img/fully-approved.png" class="imgWaterMark")
                  img(v-if="imItems.imStatus == 5" src="img/withdraw.png" class="imgWaterMark")
                  img(v-if="imItems.imStatus == 8" src="img/rejected.png" class="imgWaterMark")
                table(class="view-width ml-3" border="1" style="border:1px solid black;border-collapse: collapse;text-align:center;z-index:100;")
                  tbody
                    tr
                      td(width="30%") 
                        b Name/Position
                      td(width="30%") 
                        b Comment
                      td(width="30%")
                        b Signature
                    tr(v-for="(item, index) in imItems.imWorkflow" v-if="item.postAs == 'projectTeam'" height="80px")
                      td(width="40%" class="px-3 pt-1" style="text-align:left")
                        b {{item.positionAs}}
                        br
                        p(v-if="item.fullname") {{ item.fullname }} / {{ item.title }}
                        p(v-else) {{ item.name }} / {{ item.title }}
                      td {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                      td
                        div(v-if="item.status == 7" class="approved") 
                          img(src="../assets/check-64.png" style="width:25px;")
                          br
                          | {{ getTanggal(item.date) }}<br />
                        div(v-else-if="item.status == 8" class="approved") 
                          img(src="../assets/close-64.png" style="width:25px;")
                          br
                          | {{ getTanggal(item.date) }}<br />
                        div(v-else class="approved ff0000") &nbsp; <br />&nbsp; <br />&nbsp; <br />  
            p(class="ma-0 pt-2" style="font-size:14px;font-weight:bold;color:red;") Scan QR code to validate the correctness of information regarding the digital signatures on this document.
            p(class="ma-0 pa-0")
              img(class="ma-0 pa-0" :src="`${API_URL}/qr/generate/${imItems.imNo}/${imItems.imType}`" style="vertical-align:middle;width:150px;")      
</template>

<script>
import axios from 'axios';
import { mapState } from "vuex";
import * as i18n from "../data/i18n.json";
export default {
  name: "ProposalViewEmail",
  props: {
    dialogType: String,
    imItems: Object,
    // userDetail: Object,
    activeStatus: Number,
    viewer: Object
  },
  data: () => ({
    i18n: i18n.default,
    approvalBtn: false,
    forwardDialog: false,
    forwardDialog2: false,
    approvalDialog: false,
    approvalDialog2: false,
    replyDialog: false,
    replyDialog2: false,
    comment: null,
    approval:null,
    users: [],
    select: {},
    forwardNote: null,
    replyNote: null,
    userForward: {},
    tembusan: [],
    projectOwner: ''
  }),
  computed: {
    ...mapState(["API_URL", "WE_URL"]),
    reviewer: function() {
      let result = [];
      result.push(this.imItems.imUser);
      for (const wf of this.imItems.imWorkflow) {
        if(typeof wf.fullname === 'undefined'){
          this.$set(wf, 'fullname', wf.name);
        }
        if (wf.status == 9 || wf.status == 3)  break;
        result.push(wf);
      }
      return result;
    },
    jabatan: function() {
      if(this.select === this.imItems.imUser){
        return this.select.title + ' (Initiator)';
      }
      return this.select.title;
    },
    titleUser: function() {
      return this.userForward.title;
    }
  },
  mounted: async function() {
    this.approval = this.imItems.imStatus == 3 ? '3' : '7';
    
    let userDatas = await this.getUsers();
    for (const item of userDatas.data) {
      this.users.push(item);
    }

    if(this.imItems.imCC){
      for(const item of this.imItems.imCC){
        this.tembusan.push(item.nik);
      }
    }    
    for (const item of this.imItems.imWorkflow) {
      if(item.positionAs == 'Project Owner') this.projectOwner = item.name;
    }
  },
  methods: {
    getUsers: async function() {
      const config = {
        method: "get",
        url: `${this.WE_URL}/api/user`,
        auth: {
          username: 'imemo',
          password: 'Ang3lT3n4n!#'
        },
      };
      const dataUser = await axios(config);
      return dataUser;
    },
    routeName(val){
      if([1,2,3].includes(val)){
        return 'Edit IM Budget';
      }else if(val == 4){
        return 'Edit IM Proposal Investasi';
      }else if(val == 5){
        return 'Edit IM General';
      }else if(val == 6){
        return 'Edit IM Announcement';
      }else if(val == 7){
        return 'Edit Document Legal F1';
      }else if(val == 8){
        return 'Edit Document Legal F2';
      }else if(val == 9){
        return 'Edit IM Treasury';
      }else if(val == 10){
        return 'Edit IM Forex';
      }
    },
    getEditUrl(imType, imId) {
      if([1,2,3].includes(imType)){
        return 'im-budget/edit/' + imId;
      }else if(imType == 4){
        return 'im-proposal-investasi/edit/' + imId;
      }else if(imType == 5){
        return 'im-non-budget/edit/' + imId;
      }else if(imType == 6){
        return 'im-announcement/edit/' + imId;
      }else if(imType == 7){
        return 'doc-legal-f1/edit/' + imId;
      }else if(imType == 9){
        return 'im-treasury/edit/' + imId;
      }else if(imType == 10){
        return 'im-forex/edit/' + imId;
      }
    },
    printIM: function(id) {
      printJS({
        printable: id, 
        type: 'html',
        targetStyles: ['*']
      });
    },
    getTanggal: function(tgl) {
      let monthNames = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
      let tanggal = new Date(tgl);
      let month = tanggal.getMonth();
      let date = tanggal.getDate() < 10 ? '0'+tanggal.getDate() : tanggal.getDate();
      return date+' '+monthNames[month]+' '+tanggal.getFullYear();
    },
    download(files) {
      if (Array.isArray(files)) {
        for (const key in files) {
          window.open(`${this.API_URL}/fileupload/${files[key]}`, '_blank');
        }
      } else {
        window.open(`${this.API_URL}/fileupload/${files}`, '_blank');
      }
    },
    getFormatCurrency: function(value){
      const formatter = new Intl.NumberFormat({
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
      })
      return formatter.format(value);
    }
  },
  watch: {
    approvalDialog2 (val) {
      if (!val) return
      if(this.$route.name == `Approval Forex Landing Page`){
        const config = {
          method: "put",
          url: `${this.API_URL}/forex/update/requests`,
          headers: {"Authorization": `Bearer ${this.$route.params.token}`},
          data: {_id: this.imItems._id, status: parseInt(this.approval), comment: this.comment, backto: parseInt(this.approval) == 3 ? this.select : null}
        };
        axios(config).then(res => {
          if (res.status == 200) {
            setTimeout(() => {
                this.dialog2 = false;
                this.dialog = false;
                location.reload();
              },
            1000);
          }
        });
      }else{
        const config = {
          method: "put",
          url: `${this.API_URL}/api/update/requests`,
          headers: {"Authorization": `Bearer ${this.$route.params.token}`},
          data: {_id: this.imItems._id, status: parseInt(this.approval), comment: this.comment, backto: parseInt(this.approval) == 3 ? this.select : null}
        };
        axios(config).then(res => {
          if (res.status == 200) {
            setTimeout(() => {
                this.dialog2 = false;
                this.dialog = false;
                location.reload();
              },
            1000);
          }
        });
      }
    },
    forwardDialog2 (val) {
      if (!val) return
      if(this.$route.name == `Approval Forex Landing Page`){
        const config = {
          method: "post",
          url: `${this.API_URL}/forex/requests/forward`,
          headers: {"Authorization": `Bearer ${this.$route.params.token}`},
          data: {_id: this.imItems._id, userId: this.userForward.nik, note: this.forwardNote, by: this.viewer._id, reply: 0}
        };
        axios(config).then(res => {
          if (res.status == 200) {
            setTimeout(() => {
                this.dialog2 = false;
                this.dialog = false;
                location.reload();
              },
            1000);
          }
        });
      }else{
        const config = {
          method: "post",
          url: `${this.API_URL}/api/requests/forward`,
          headers: {"Authorization": `Bearer ${this.$route.params.token}`},
          data: {_id: this.imItems._id, userId: this.userForward.nik, note: this.forwardNote, by: this.viewer._id, reply: 0}
        };
        axios(config).then(res => {
          if (res.status == 200) {
            setTimeout(() => {
                this.dialog2 = false;
                this.dialog = false;
                location.reload();
              },
            1000);
          }
        });
      }
    },
    replyDialog2 (val){
      if(!val) return
      if(this.$route.name == `Approval Forex Landing Page`){
        const config = {
          method: "post",
          url: `${this.API_URL}/forex/requests/forward`,
          headers: {"Authorization": `Bearer ${this.$route.params.token}`},
          data: {_id: this.imItems._id, userId: this.viewer.sender, note: this.replyNote, by: this.viewer._id, reply: 1}
        };
        axios(config).then(res => {
          if (res.status == 200) {
            setTimeout(() => {
                this.dialog2 = false;
                this.dialog = false;
                location.reload();
              },
            1000);
          }
        });
      }else{
        const config = {
          method: "post",
          url: `${this.API_URL}/api/requests/forward`,
          headers: {"Authorization": `Bearer ${this.$route.params.token}`},
          data: {_id: this.imItems._id, userId: this.viewer.sender, note: this.replyNote, by: this.viewer._id, reply: 1}
        };
        axios(config).then(res => {
          if (res.status == 200) {
            setTimeout(() => {
                this.dialog2 = false;
                this.dialog = false;
                location.reload();
              },
            1000);
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.print-bg {
  background: rgb(204,204,204) !important;
}
.print-bg > div{
  text-align:center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin:0 auto;
  display:inline-block;
  text-align:initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:3px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  font-size: 11px;
  padding: 15px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.top-align {
  vertical-align:top;
}

/* The containerLbl */
.containerLbl {
  position: relative;
  padding-left: 20px;
  margin: 0 30px 0 10px;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.containerLbl input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.containerLbl:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.containerLbl input:checked ~ .checkmark {
  background-color: #000000;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.containerLbl input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.containerLbl .checkmark:after {
  left: 5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
    .pagebreak { page-break-after: always; } /* page-break-after works, as well */
}
#background {
  position:absolute;
  z-index:0;
  display:block;
  top:0px;
  left:0px;
  text-align: right;
  width: 100%;
}
.imgWaterMark {
  width: 201px;
  position:absolute;
  top:0px;
  right:35px;
}
</style>